import React, { useState } from "react";

// component
import {
  Heading,
  Flex,
  Box,
  Text,
  useMatchBreakpoints,
  ButtonV1,
} from "@edricphan2022/uikit";
import Container from "../../components/Container";
import ContentHeader from "../../components/ContentHeader";
import CarouselAboutUS from "../../components/CarouselAboutUS";
import { LetterIcon, TeleIcon } from "@edricphan2022/uikit";
import FlexLayout from "../../components/LayoutFlex";
//styled
import {
  BannerBox,
  BoxAboutUs,
  BoxBlockChain,
  BoxOurValue,
  BoxPartners,
  BoxOurTeam,
  BoxFaq,
  BoxInTouch,
  BoxTitleOurValue,
} from "./style";

import BlockchainDev from "./BlockChainDev";
import SercurityServices from "./SercurityServices";
import OurPartners from "./OurPartners";
import OurTeam from "./OurTeams";
import OrbitFaq from "./OrbitFaq";
import FormOrbit from "./FormOrbit";
import IndustryExpertise from "./IndustryExpertise";
import Linked from "../../assets/Home/link.svg";
import SliderV2 from "./SliderV2";

const HomeOrbit: React.FC = () => {
  const { isDesktop } = useMatchBreakpoints();
  return (
    <>
      <BannerBox as="section">
        <Container>
          <SliderV2 />
        </Container>
      </BannerBox>
      <Flex as="section" pt="36px" flexDirection="column">
        <Container>
          <Flex flexDirection="column">
            <BoxAboutUs>
              <ContentHeader text="Who we are?" title="About Us" />
              <CarouselAboutUS />
            </BoxAboutUs>
            <BoxBlockChain>
              <ContentHeader text="What we do?" title="SERVICES" />
              <BlockchainDev />
            </BoxBlockChain>
          </Flex>
        </Container>
        <BoxOurValue>
          <Container>
            <BoxTitleOurValue>
              <Box>
                <h3>What we do?</h3>
                <h1>Our Values</h1>
              </Box>
              <p>
                Wikex Exchange more than a technology partner. <br />
                We worked as a trusted long-term companion on the journey to
                digital transformation and business success
              </p>
            </BoxTitleOurValue>
            <SercurityServices />
          </Container>
        </BoxOurValue>
        <IndustryExpertise />
        <BoxFaq>
          <Container>
            <OrbitFaq />
          </Container>
        </BoxFaq>
        <BoxInTouch>
          <Container>
            <FlexLayout className="cus-intouch-orbit">
              <Box>
                <ContentHeader text="Talk to an expert" title="GET IN TOUCH" />
                <h5>
                  Our team is happy to answer your questions.
                  Fill out the form and we'll get back to you as soon as
                  possible.
                </h5>
                <Box pt="46px">
                  <Flex>
                    <LetterIcon />
                    <p>admin@uniorbit.org</p>
                  </Flex>
                  <Flex pt="7px">
                    <img src={Linked} alt="" />
                    <p>linkedin.com/in/technology-orbit</p>
                  </Flex>
                </Box>
              </Box>
              <Box>
                <Box>
                  <FormOrbit />
                </Box>
              </Box>
            </FlexLayout>
          </Container>
        </BoxInTouch>
      </Flex>
    </>
  );
};

export default HomeOrbit;
